







































































import { Component, Vue } from "vue-property-decorator";
import TopBarMember from "@/components/TopBarMember.vue";
import LottoMenu from "@/components/LottoMenu.vue";
import FooterIndex from "@/components/Footer.vue";


@Component({
  components: {
    TopBarMember,
    LottoMenu,
    FooterIndex,
  },
})
export default class Lottery extends Vue {}
